import GoogleMapLocationPicker from './GoogleMapLocationPicker';
import React, { useEffect, useState } from 'react';

export const LocationPickerWrapper = ({
  containerStyle,
  locationCoords,
  isVisible,
  draggable,
}) => {
  const [latLong, setLatLong] = useState(null) as any;

  useEffect(() => {
    setLatLong(Object.keys(locationCoords)?.length > 0 ? locationCoords : null);
  }, [locationCoords]);

  const updateCoordinates = async (latLong) => {
    setLatLong(latLong);
  };

  if (!isVisible) return null;
  
  return (
    <div>
      <GoogleMapLocationPicker
        initialCenter={latLong}
        styles={{ container: containerStyle }}
        onMapLocationChanged={updateCoordinates}
        draggable={draggable}
      />
    </div>
  );
};
